import api from "./client";

export const gastosApi = {
  getAll: (params = {}) => api.get("/gastos/", { params }).then(({ data }) => data),
  create: (data) => api.post("/gastos/", data),
  update: (id, data) => api.patch(`/gastos/${id}/`, data),
  remove: (id) => api.delete(`/gastos/${id}/`),
};



